import { render, staticRenderFns } from "./cModalPension.vue?vue&type=template&id=1e0c81e4"
import script from "./cModalPension.vue?vue&type=script&lang=js"
export * from "./cModalPension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports